import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { DropdownGroup, StyledLabel, Required, DropdownBody, DropdownHeader, DropdownItem, DropdownValue, DropdownIcon } from './styles';

const DropdownQuestion = ({
  label, options, value, onChange, required, name,
}) => {
  const isArray = Array.isArray(options);
  const [isOpen, setOpen] = useState(false);
  const toggleDropdown = () => setOpen(prev => !prev);
  const wrapperRef = useRef(null);

  useEffect(() => {
    // Click outside of element closes dropdown
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target) && isOpen) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef, isOpen]);

  const handleOnClick = (e) => {
    toggleDropdown();
    onChange(e);
  };

  const isValid = (optionValue) => {
    if (options.find(op => op.value === optionValue) && parseInt(optionValue) > 0) {
      return true;
    }
    return false;
  };

  return (
    <DropdownGroup>
      <StyledLabel>
        {label}
        {label && required && <Required>*</Required>}
      </StyledLabel>
      <DropdownHeader className="dropdown-header" onClick={toggleDropdown} isValid={isValid(value)}>
        <DropdownValue>
          {value ? options.find(item => item.value === value).text : 'Select'}
        </DropdownValue>
        <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0L4 4L8 0H0Z" fill="#1C2833" /></svg>
      </DropdownHeader>
      <DropdownBody isOpen={isOpen} ref={wrapperRef}>
        {isArray && options.map(item => (
          <DropdownItem className="dropdown-item" key={`${name}-${item.value}`} onClick={handleOnClick} id={item.value}>
            <DropdownIcon>
              {item.value === value && <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M4.0001 7.7799L1.2201 4.9999L0.273438 5.9399L4.0001 9.66656L12.0001 1.66656L11.0601 0.726562L4.0001 7.7799Z" fill="white" /></svg>}
            </DropdownIcon>
            {item.text}
          </DropdownItem>
        ))}
      </DropdownBody>
    </DropdownGroup>
  );
};

DropdownQuestion.propTypes = {
  label: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string.isRequired),
    PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.any.isRequired,
      text: PropTypes.string.isRequired,
    })),
  ]).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

DropdownQuestion.defaultProps = {
  label: '',
  onChange: null,
  required: false,
};

export default DropdownQuestion;
